<template>
  <div class="right_container" style="padding:0 0 0 0;" v-if="data_finished">
    <div class="bar create_project" :style="'height:'+bar_height+'px;'">
      <span class="fl">编辑项目</span>
      <!--<span class="auto_saved" v-if="auto_saved">{{auto_text}}</span>-->
    </div>
    <div :style="'overflow: auto;height:'+(height-bar_height)+'px;width:' + (width - 10) + 'px;'">
      <div :style="'width:1000px;'">
        <div v-for="(item,index) in templates" :key="index+''">
          <v-datepicker
            v-if="item.type=='TimePicker'"
            :moduel="item"
            :projectData="project_data"
            v-model="project_data[item.key_name]"
            :ref="'project'+item.key_name"
            v-on:listenToChildEvent="checkParams"
            type="edit"
          ></v-datepicker>
          <v-input
            v-if="item.type=='input'"
            :moduel="item"
            :projectData="project_data"
            v-model="project_data[item.key_name]"
            :ref="'project'+item.key_name"
            :input_callback="set_add_project_input"
            :projectNum="projectNum"
            type="edit"
          ></v-input>
          <v-select
            v-if="item.type=='select'"
            :moduel="item"
            :projectData.sync="project_data"
            v-model="project_data[item.key_name]"
            :ref="'project'+item.key_name"
            v-on:listenToChildEvent="checkParams"
            type="edit"
          ></v-select>
          <v-selectObj
            v-if="item.type=='select_by_api'&&item.key_name != 'customer_ids'"
            :moduel="item"
            :projectData.sync="project_data"
            v-model="project_data[item.key_name]"
            :input_callback="set_add_project_input_user"
            :ref="'project'+item.key_name"
            type="edit"
          ></v-selectObj>
          <v-selectObj
            v-if="item.type=='select_by_api'&&item.key_name == 'customer_ids'"
            :moduel="item"
            :projectData.sync="project_data"
            v-model="project_data[item.key_name]"
            :input_callback="set_add_project_input_client"
            :ref="'project'+item.key_name"
            type="edit"
          ></v-selectObj>
          <uc_editor
            v-if="item.type=='text'"
            :moduel="item"
            :data="project_data"
            v-model="project_data[item.key_name]"
            :ref="'project'+item.key_name"
            :input_callback="set_edit_project_description"
            type="edit"
          ></uc_editor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      edit_project_sunbmit: false,
      bar_height: 40,
      btn_height: 54,
      project_tips: "",
      timer: "",
      customer_ids: [],
      user_list: [],
      project_user_list: [],
      content: "",
      name: "",
      createTime: "",
      add_project_sunbmit: false,
      // show_ellipsis:false,
      description_high: 0,
      function_type1: "",
      project_dataInit: {},
      project_data: {},
      project_id: "",
      projectNum: "",
      data_finished: false
    };
  },
  props: [
    "height",
    "width",
    "templates",
    "web_token",
    "user_info",
    "web_url",
    "project_detail"
  ],
  // store,
  methods: {
    set_edit_project_description: function(_content, _height) {
      this.project_data.description = _content;
      this.project_data.description_high = _height;
      if (_content != "") {
        this.edit_project();
      }
    },
    set_add_project_input: function(_key_name, _height) {
      console.log(_height);
      if (_key_name == "name") {
        this.project_data.name_high = _height;
      } else if (_key_name == "keyword") {
        this.project_data.keyword_high = _height;
      } else if (_key_name == "objective") {
        this.project_data.objective_high = _height;
      }
      console.log("content", this.project_data[_key_name]);
      if (this.project_data[_key_name] != "") {
        this.edit_project();
      }
    },
    set_add_project_input_user: function(_height) {
      this.role_change();
      this.project_data.user_high = _height;
      console.log(_height);
      this.checkParams();
    },
    set_add_project_input_client: function(_height) {
      this.project_data.client_high = _height;
      this.checkParams();
    },
    backToLogin() {
      this.$router.push("/login");
    },
    // 关闭添加
    close_edit_wrapper() {
      var that = this;
      this.$confirm(
        "正在编辑项目，离开会丢失录入的内容，是否确定离开？",
        "提示",
        {
          cancelButtonText: "继续编辑",
          confirmButtonText: "确定离开",
          type: "warning"
        }
      )
        .then(() => {
          this.$router.push({
            path: "/main/project/project_files/" + id,
            query: { id: id }
          });
        })
        .catch(() => {});
    },
    listenToChildGet_focus() {
      this.show_save = true;
    },
    checkParams() {
      this.role_change();
      this.edit_project_sunbmit = true;
      for (var i = 0; i < this.templates.length; i++) {
        if (this.templates[i].required) {
          if (
            this.project_data[this.templates[i].key_name] == "" ||
            this.project_data[this.templates[i].key_name] == []
          ) {
            this.edit_project_sunbmit = false;
            break;
          }
        }
      }
      //   this.edit_project();
      if (this.edit_project_sunbmit) {
        this.edit_project();
      }
    },
    // 人员改变 项目角色不能重复
    role_change() {
      var user_role = ["leader_user_ids", "manage_user_ids", "join_user_ids"];
      for (var i = 0; i < this.templates.length; i++) {
        if (user_role.indexOf(this.templates[i].key_name) > -1) {
          var ref = "project" + this.templates[i].key_name;
          if (ref in this.$refs) {
            this.$refs[ref][0].user_change();
          }
        }
      }
    },
    editors_clear: function(name) {
      for (var i = 0; i < this.templates.length; i++) {
        var ref = name + this.templates[i].key_name;
        if (ref in this.$refs) {
          this.$refs[ref][0].clear();
        }
      }
    },
    // 编辑项目
    edit_project(edit_type, _call_back) {
      this.project_data.web_token = this.web_token;
      this.$http
        .post(
          this.web_url + "/project/" + this.project_id + "/edit",
          this.project_data,
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.project_detail(this.project_id, "detail");
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          } else {
            //   this.edit_tips( res.data.message);
            //   this.show_save = false;
            // var _this = this;
            //  clearInterval(this.timer);
            //  this.project_tips =  res.data.message;
            //  this.timer = setInterval(function(){
            //     _this.project_tips =  '';
            //  },2000);
          }
          if (typeof _call_back === "function") {
            _call_back();
          }
        })
        .catch(function(res1) {
          var _this = this;
          clearInterval(this.timer);
          this.project_tips = "网络出错";
          this.timer = setInterval(function() {
            _this.project_tips = "";
          }, 2000);
        });
    },
    editors_clear: function(name) {
      for (var i = 0; i < this.templates.length; i++) {
        var item = this.templates[i];
        var ref = name + item.key_name;
        if (ref in this.$refs) {
          this.$refs[ref][0].clear();
        }
      }
    },
    // 初始化编辑项目的值
    init_projectData() {
      for (var i = 0; i < this.templates.length; i++) {
        var item = this.templates[i];
        var project_users = [
          "join_user_ids",
          "leader_user_ids",
          "manage_user_ids"
        ];
        if (project_users.indexOf(item.key_name) > -1) {
          var project_user = this.project_dataInit.project_user;
          var users = [];
          for (var a = 0; a < project_user.length; a++) {
            var item2 = project_user[a];
            if (item2.key_name == item.key_name) {
              var user = { user_id: item2.user_id, username: item2.username };
              users.push(user);
            }
          }
          this.project_data[item.key_name] = users;
        } else if (item.key_name == "customer_ids") {
          var customer_ids = this.project_dataInit.customer_ids;
          var customers = [];
          for (var a = 0; a < customer_ids.length; a++) {
            var item2 = customer_ids[a];
            var customer = {
              khmc: item2.khmc,
              khdm: item2.khdm,
              clientlevel: item2.clientlevel,
              khjc: item2.khjc
            };
            customers.push(customer);
          }
          this.project_data[item.key_name] = customers;
        } else if (
          item.type == "select" &&
          this.project_dataInit[item.key_name] != null &&
          this.project_dataInit[item.key_name] != ""
        ) {
          this.project_data[item.key_name] = this.project_dataInit[
            item.key_name
          ].id;
        } else {
          this.project_data[item.key_name] = this.project_dataInit[
            item.key_name
          ];
        }
      }
      this.data_finished = true;
      console.log(project_data);
    },
    //获取项目详情
    get_project_detail() {
      // this.selected= 'project_name';
      console.log("get_project_detail");
      var _this = this;
      this.$http
        .post(
          this.web_url + "/project/" + this.project_id,
          { web_token: this.web_token },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            console.log(res.data.data.project_num);
            this.project_dataInit = res.data.data;
            this.projectNum = res.data.data.project_num;
            this.init_projectData();
          } else if (res.data.status == "error") {
            if (res.data.message == "没有权限！") {
              this.function_type = 1;
              this.getData("");
            }
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          // console.log(res1);
        });
    }
  },
  mounted() {
    this.project_id = this.$route.query.id;
    this.get_project_detail();
  },
  created() {}
};
</script>




// WEBPACK FOOTER //
// src/page/project/project_detail.vue